// @ts-nocheck
import axios from '../utils/axios';
import { TICKET_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const getCombinationLockList = catchAsync(async params => {
    const response = await axios.get(`${TICKET_API_ENDPOINT}/combination-lock/list`, { params });

    return response.data;
});

const getCombinationLockItem = catchAsync(async id => {
    const response = await axios.get(`${TICKET_API_ENDPOINT}/combination-lock/template/${id}`);

    return response.data;
});

const lockCombinationLockItem = catchAsync(async (id, data) => {
    const response = await axios.patch(`${TICKET_API_ENDPOINT}/combination-lock/template/lock/${id}`, data);
    return response.data;
});

const unlockCombinationLockItem = catchAsync(async (id, data) => {
    const response = await axios.patch(`${TICKET_API_ENDPOINT}/combination-lock/template/unlock/${id}`, data);
    return response.data;
});

const lockCombinationLockItemByTicket = catchAsync(async ({ ticketId, ...data }) => {
    const response = await axios.patch(`${TICKET_API_ENDPOINT}/combination-lock/ticket/lock/${ticketId}`, data);
    return response.data;
});

const unlockCombinationLockItemByTicket = catchAsync(async ({ ticketId, ...data }) => {
    const response = await axios.patch(`${TICKET_API_ENDPOINT}/combination-lock/ticket/unlock/${ticketId}`, data);
    return response.data;
});

const createCombinationLockItem = catchAsync(async formData => {
    const response = await axios.post(`${TICKET_API_ENDPOINT}/combination-lock/template/lock`, formData);

    return response.data;
});

const updateCombinationLockItem = catchAsync(async (id, formData) => {
    const response = await axios.put(`${TICKET_API_ENDPOINT}/combination-lock/template/${id}`, formData);

    return response.data;
});

const CombinationLockService = {
    getCombinationLockList,
    getCombinationLockItem,
    createCombinationLockItem,
    updateCombinationLockItem,
    lockCombinationLockItem,
    unlockCombinationLockItem,
    lockCombinationLockItemByTicket,
    unlockCombinationLockItemByTicket,
};

export default CombinationLockService;
